
import React from 'react';
import {
  CardWrapper,
  TopRow,
  BottomRow,
  BrandText,
  GenericText,
  MetaText,
  PriceText,
  CartItemMeta
} from './styles';
import { Typography } from '@mui/material';

 const ymdUTC = (d) => {
  if (!d) return null;
  const dt = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(dt.getTime())) return null;
  return dt.toISOString().slice(0, 10); // YYYY-MM-DD
};

const isExpired = (expiryDate) => {
  const exp = ymdUTC(expiryDate);
  if (!exp) return false;
  const today = ymdUTC(new Date());
  return exp < today; // valid through expiry day
};

const SalesCard = ({ item, addToCart, cartItems = [] }) => {
  // ✅ inventory now uses itemId (populated) for both medicines + products
  const med = item?.itemId?.medicineId;

const brand =
  item?.itemId?.name ||      // products
  med?.brandName ||          // medicines
  item?.productName ||
  item?.name ||
  "Unnamed item";

const generic = med?.genericName || "";


  const strength =
    item?.itemId?.strength ||
    item?.strength ||
    "";

   



  // const batchNo = item?.batchNo || "-";
  const stock = Number(item?.quantity ?? 0);

  const unitPrice =
    item?.retailPrice ?? item?.unitPrice ?? item?.price ?? null;

  // Find qty in cart for this item + batch
  const cartQty =
    cartItems.find(
      (c) => c._id === item._id && c.batchNo === item.batchNo
    )?.qty || 0;

  const remainingStock = Math.max(0, stock - cartQty);

  const isOutOfStock = stock <= 0;
  const reachedMax = cartQty >= stock && stock > 0;

  const expired = isExpired(item?.expiryDate);

  const disabled = isOutOfStock || reachedMax || expired;

  

  return (
    <CardWrapper
      onClick={() => {
        if (!disabled) addToCart(item);
      }}
      style={{
        opacity: disabled ? 0.55 : 1,
        pointerEvents: disabled ? "none" : "auto",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      <TopRow>
        <div style={{ textAlign: 'left' }}>
          <BrandText>{brand}</BrandText>

          {(generic || strength) && (
            <GenericText>
              {generic}
              {generic && (strength) ? " • " : ""}
              {strength}
            </GenericText>
          )}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', width: '30%', alignItems: 'flex-end' }}>
          <CartItemMeta style={{ color: '#1976d2', background: 'rgba(25, 118, 210, 0.1)', borderRadius: '3px', padding: '1px 7px' }}>
            {item.batchNo && (
              <Typography variant="body2" sx={{ fontWeight: '600' }}>
                {item.batchNo}
              </Typography>
            )}
          </CartItemMeta>

          <CartItemMeta>
            {typeof item.quantity === 'number' && (
              <Typography variant="body2" sx={{ fontWeight: '600' }}>
                <span style={{ color: 'darkgrey' }}>Stock: </span>
                {remainingStock}
              </Typography>
            )}
          </CartItemMeta>
        </div>
      </TopRow>

      <BottomRow>
        {unitPrice !== null && (
          <PriceText>Rs {Number(unitPrice).toFixed(2)}</PriceText>
        )}

        {isOutOfStock && (
          <div style={{ marginTop: "6px", textAlign: 'right' }}>
            <MetaText style={{ color: "red", fontWeight: 600 }}>
              Out of Stock!
            </MetaText>
          </div>
        )}

        {reachedMax && !isOutOfStock && (
          <div style={{ marginTop: "6px" }}>
            <MetaText style={{ color: "#EF5350", fontWeight: 600, textAlign: 'left' }}>
              Stock Limit Reached!
            </MetaText>
          </div>
        )}

        {item.expiryDate && !isOutOfStock && (!reachedMax || expired) && (
  <div style={{ marginTop: "6px" }}>
    <MetaText
      style={{
        color: expired ? "#EF5350" : "grey",
        fontWeight: 600,
        textAlign: "left",
      }}
    >
      {expired ? "Expired" : (
        <>
          <span style={{ color: "darkgrey" }}>EXP: </span>
          {new Date(item.expiryDate).toLocaleDateString("en-GB")}
        </>
      )}
    </MetaText>
  </div>
)}



      </BottomRow>
    </CardWrapper>
  );
};

export default SalesCard;
